import {makeStyles} from "@material-ui/core/styles";
import {topHeight} from "../../../stores/NavigateStore";

export const  useStyles = makeStyles((theme) => ({
    root:{
        width: '100%',
        minHeight: `calc(100vh - ${topHeight}px)`,
        marginTop: topHeight,
        padding: 24,
        boxSizing:'border-box',
    }

}));

